import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatLegacyProgressBarModule as MatProgressBarModule } from "@angular/material/legacy-progress-bar";
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from "@angular/material/legacy-progress-spinner";
import { CustomPipesModule } from "@app/_pipes/custom-pipes.module";
import { LoaderComponent } from "./loader.component";

@NgModule({
	declarations: [LoaderComponent],
	imports: [CommonModule, MatProgressSpinnerModule, MatProgressBarModule, CustomPipesModule],
	exports: [LoaderComponent],
	providers: [],
})
export class LoaderModule {}
